import * as React from "react";
import LeftMenuBar from "./modules/base/components/LeftMenuBar";
import TopAppbar from "./modules/base/components/TopAppbar";
import {Provider, useSelector} from "react-redux";
import ContentRouter from "./modules/base/components/ContentRouter";
import {BrowserRouter} from "react-router-dom";
import {Snackbar} from "./modules/base/components/Snackbar";
import "./static/css/DarkVersionStyle.css";
import {store} from "./store/store";

// Custom Alert Component
const CustomAlert: React.FC<{ message: string; onClose: () => void }> = ({message, onClose}) => {
    return (
        <div style={styles.overlay}>
            <div style={styles.alertBox}>
                <span style={styles.closeButton} onClick={onClose}>&times;</span>
                <p>{message}</p>
                <button style={styles.okButton} onClick={onClose}>OK</button>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: 'fixed' as 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    alertBox: {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        width: '300px',
        maxWidth: '80%',
        textAlign: 'center' as 'center',
        position: 'relative' as 'relative',
    },
    closeButton: {
        position: 'absolute' as 'absolute',
        top: '10px',
        right: '10px',
        cursor: 'pointer' as 'pointer',
        fontSize: '20px',
        fontWeight: 'bold' as 'bold',
        color: '#aaa',
    },
    okButton: {
        padding: '10px 20px',
        fontSize: '16px',
        border: 'none',
        borderRadius: '5px',
        backgroundColor: '#28a745',
        color: '#fff',
        cursor: 'pointer' as 'pointer',
        marginTop: '20px',
    },
};

// Main App Component
function App() {
    //@ts-ignore
    const showBar = useSelector((state: any) => state.base.showBars);
    const [alertMessage, setAlertMessage] = React.useState<string>('');
    const [isAlertVisible, setIsAlertVisible] = React.useState<boolean>(false);

    React.useEffect(() => {
        // Override the default window.alert function
        window.alert = (message: string) => {
            setAlertMessage(message);
            setIsAlertVisible(true);
        };
    }, []);

    const closeAlert = () => {
        setIsAlertVisible(false);
    };

    return (
        <React.Fragment>
            <Provider store={store}>
                <BrowserRouter>
                    <div className="dark-version"
                         style={{backgroundColor: "aaa", top: "0px", left: "0px", height: "100vh"}}>
                        {showBar && <LeftMenuBar/>}
                        <main id="dashboard-div" style={{
                            marginLeft: showBar ? "80px" : "0px",
                            height: "100vh",
                            overflow: showBar ? "hidden" : "auto",
                        }}>
                            {showBar && <TopAppbar/>}
                            <ContentRouter/>
                        </main>
                    </div>
                    <Snackbar/>
                </BrowserRouter>
                {isAlertVisible && <CustomAlert message={alertMessage} onClose={closeAlert}/>}
            </Provider>
        </React.Fragment>
    );
}

export default App;
